var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAttention(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_1152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92813 4.24418C8.41364 3.43501 9.58636 3.43501 10.0719 4.24418L16.5395 15.0235C17.0394 15.8567 16.4392 16.9167 15.4676 16.9167H2.53238C1.56076 16.9167 0.960621 15.8567 1.46051 15.0235L7.92813 4.24418Z",
    stroke: "#EC6500",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53885 12.3918C9.52842 12.6602 9.30782 12.8724 9.03923 12.8724H8.96073C8.69214 12.8724 8.47154 12.6602 8.46111 12.3918L8.24999 6.95939C8.23345 6.53376 8.57403 6.17969 8.99998 6.17969C9.42593 6.17969 9.76651 6.53376 9.74997 6.95939L9.53885 12.3918ZM8.41 15.1562C8.24083 14.987 8.15625 14.7904 8.15625 14.5662C8.15625 14.3379 8.24083 14.1391 8.41 13.9699C8.57917 13.8007 8.77583 13.7162 8.99998 13.7162C9.22413 13.7162 9.42079 13.8007 9.58996 13.9699C9.75912 14.1391 9.84371 14.3379 9.84371 14.5662C9.84371 14.7904 9.75912 14.987 9.58996 15.1562C9.42079 15.3211 9.22413 15.4036 8.99998 15.4036C8.77583 15.4036 8.57917 15.3211 8.41 15.1562Z",
    fill: "#EC6500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_1152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/iconAttention.492e7e087f3834b5ac5b0d0f434544b5.svg";
export { ForwardRef as ReactComponent };